import { render, staticRenderFns } from "./TheNote.vue?vue&type=template&id=dfd625ea&scoped=true&"
import script from "./TheNote.vue?vue&type=script&lang=js&"
export * from "./TheNote.vue?vue&type=script&lang=js&"
import style0 from "./TheNote.vue?vue&type=style&index=0&id=dfd625ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd625ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSpacer})
